import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { LoginContainer, LoginContainerHeader } from "./styles";
import {
  CenterContainer,
  InputField,
  LabelInput,
  FieldElement,
  RegisterButton,
} from "../registerPageContent/styles";
import { useAuth } from "../../contexts/AuthContext";

const LoginPageContent = () => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("Incorrect login information");
  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  const { login } = useAuth();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email && password) {
      // login(email, password).then(() => {
      //   navigate("/dashboard", { replace: true });
      // });
      login(email, password).then(() => {
        setShowError(false);
        navigate("/dashboard", { replace: true });
      }).catch(err => {
        setShowError(true);
      })
    }
  };

  return (
    <CenterContainer>
      <LoginContainer>
        <LoginContainerHeader>Login</LoginContainerHeader>
        {showError ? (<><div className="alert alert-danger" role="alert">
          {errorMsg}
        </div></>) : null}

        <form onSubmit={handleSubmit}>
          <FieldElement>
            <LabelInput htmlFor="email">Email</LabelInput>
            <InputField
              autoComplete="on"
              value={email}
              type="email"
              name="email"
              id="email"
              placeholder="Enter email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </FieldElement>

          <FieldElement>
            <LabelInput htmlFor="password">Password</LabelInput>
            <InputField
              autoComplete="on"
              value={password}
              type="password"
              name="password"
              id="password"
              placeholder="Enter password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </FieldElement>

          <RegisterButton type="submit">Login</RegisterButton>
        </form>
      </LoginContainer>
    </CenterContainer>
  );
};

export default LoginPageContent;
